import { GridProps, SxProps } from '@mui/material'
import StylesProductsModalListContainerServiceInterface
  from '~/src/components/products/modals/products-list/container/styles/StylesProductsModalListContainerServiceInterface'

export default class StylesProductsModalListContainerServiceStyleTwo implements StylesProductsModalListContainerServiceInterface {
  public getGridItemsProps(): Partial<GridProps> {
    return {
      xl: 6,
      lg: 6,
      md: 6,
      sm: 6,
      xs: 6
    }
  }

  public getGridProps(lengthOfItems: number): Partial<GridProps> {
    return {
      columns: lengthOfItems < 3 ? 6 : 12,
      width: lengthOfItems < 3 ? '50%' : '100%',
      mx: 'auto',
      justifyContent: 'center',
      sx: {
        pr: 2
      }
    }
  }

  public getPageSx(): SxProps {
    return {}
  }
}
